import {Box, Breadcrumbs, Button, Divider, Grid, Link as MuiLink, Paper, Typography, useMediaQuery, useTheme} from '@mui/material';
import React, {useEffect, useRef, useState} from 'react'
import logo  from '../../../../assets/logo/3d-logo.png'
import {getBookingInvoice, getbookinginvoice} from '../../../../store/crm/pos';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router';
import {jsPDF} from "jspdf";
import html2canvas from "html2canvas";

import ReactToPrint from "react-to-print";
import {Link, useSearchParams} from "react-router-dom";
import ArrowBack from "../../../../assets/icon/chevron-back-outline.png";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Waveloading from '../../../loading/Waveloading';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import LanguageIcon from '@mui/icons-material/Language';
import DownloadIcon from '@mui/icons-material/Download';
import NavigateNextIconAlt from '@mui/icons-material/ChevronRight';
export const wrapper = {
    background:'white',
    padding:'15px 28px',
    borderTop:"12px solid  #72D5FF",
    borderBottom:"12px solid  #72D5FF",
    borderRadius:"13px"

};
export const logowrap ={

    display:'flex',
    justifyContent:"space-between",alignItems:'center'
};
export const heading ={
    fontFamily:'helvetica-lt-std-light',
    fontWeight:'700!important',
    fontSize:'30px!important'

};
export const content ={
    fontFamily:'helvetica-lt-std-roman',
    fontWeight:'400!important',
    fontSize:'18px!important',marginBottom:'3px',
};
export const subheading ={
    marginBottom:'3px',
    fontFamily:'helvetica-world-bold',
    fontWeight:'700!important',
    fontSize:'19px!important'
};

export const contentwrapper ={
    marginTop:'40px',
    display:'flex',
    alignItems:'center',

    // border:'1px solid red',
    // gap:"40px",
    justifyContent:"space-between",
    '@media (max-width: 768px)': {

        flexDirection: 'column',
        // alignItems: 'center',
        alignItems:'start',
    }

}

export const tablewrapper ={

    display:'flex',
    justifyContent:"space-between",
    marginTop:'15px',
    marginBottom:'15px',
    '@media (max-width: 1200px)': {
        display:'flex',
        justifyContent:'left',

    }


}
export const subfooter ={
    margin:'0 auto',
    width:"50%",
    display:'flex',
    justifyContent :'space-between',
    alignItems:'center',
    '@media (max-width: 900px)': {
        width: '80%',
    },
    '@media (max-width: 768px)': {
        width: '80%',
        flexDirection: 'column',
        alignItems: 'center',
    }
}
export const btnwrapper= {
    display: "flex",
    justifyContent: "space-between",
    alignItems: 'center',
    margin: "15px 2px",
}
export const printstyle= {
    background: "#219653",
    border: "1px solid #219653",
    color: "white",
    textTransform: "capitalize",
    ml: '10px',
    borderRadius: "3px",
    "&:hover": {
        color: "#219653",
    }

}

const Invoices = ({ booking_id: propBookingId, panelMode } = {}) => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const params = useParams()
    const booking_id = propBookingId || params.booking_id
const location = useLocation();
const id = propBookingId || params.id;
const isFromAppointment =
  location.state?.from?.includes("/crm/appointment/details/");

    const crmPOSStore = useSelector(state => state?.crmPOSStore)
    const {bookingInvoice = {}} = crmPOSStore
    
    // const invoiceRef = useRef(null)
// console.log("check",isFromAppointment)


   
    const [searchParams] = useSearchParams();
    const customerId = searchParams.get("customerId"); // this is what you need!

    //console.log("invoiceId", id);
    // console.log("customerId", bookingInvoice?.start_time,bookingInvoice?.end_time);


    const queryParams = new URLSearchParams(location.search);
    const autoDownload = queryParams.get('autoDownload');
    const scrollRef = useRef(null);

    const formatPhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return ''; // Return an empty string if phoneNumber is undefined or null
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    };
    useEffect(() => {
        //console.log("useEffect call", autoDownload);

        if (autoDownload === 'true') {
            const scrollTimer = setTimeout(() => {
                if (scrollRef.current) {
                    scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    //console.log("Scrolled to scrollRef");
                } else {
                    console.warn("scrollRef.current is null");
                }
            }, 200); // Small delay ensures it's mounted

            const pdfTimer = setTimeout(() => {
                const content = componentRef.current;

                if (!content) {
                    console.error('Content not found.');
                    return;
                }

                const pdf = new jsPDF('p', 'pt', 'a4');

                html2canvas(content, {
                    scale: 2,
                })
                    .then((canvas) => {
                        const imgData = canvas.toDataURL('image/jpeg');
                        const pdfWidth = pdf.internal.pageSize.getWidth();
                        const pdfHeight = pdf.internal.pageSize.getHeight();
                        const ratio = Math.min(pdfWidth / canvas.width, pdfHeight / canvas.height);
                        const imgWidth = canvas.width * ratio;
                        const imgHeight = canvas.height * ratio;
                        const xOffset = (pdfWidth - imgWidth) / 2;
                        const yOffset = 10;

                        pdf.addImage(imgData, 'JPEG', xOffset, yOffset, imgWidth, imgHeight);
                        pdf.save('invoice.pdf');
                    })
                    .catch((error) => {
                        console.error('Error generating PDF:', error);
                    });

            }, 13000);

            return () => {
                clearTimeout(scrollTimer);
                clearTimeout(pdfTimer);
            };
        }
    }, [autoDownload]);



// Inside your component
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const componentRef = useRef();
    const fixedHeight = '250px';
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await dispatch(getBookingInvoice(booking_id));
            setLoading(false);
        }

        fetchData();
    }, []);
    //console.log(bookingInvoice?.customer?.name)
    const navigate = useNavigate();


    const handleNewAppointment = () => {

        if (customerId) {

            navigate(`/crm/add-appointment/user/${customerId}`, {
                state: { heading: "Let’s Book the Next Appointment for this Client" }
            });
        }
    };

    const handleNavigation = () => {
        const customerName = bookingInvoice?.customer?.name;
        //console.log('Navigating with customer name:', customerName); // This line is just for debugging purposes

        // Check if the customer name is not undefined or null
        if (customerName) {
            navigate('/crm/customer-relationship-management', { state: { value: customerName } });
        } else {
            console.error('Customer name is undefined or null');
            // Handle the case where customer name is not available (e.g., show an alert or notification)
        }
    };
    const handleDownload = () => {
        const content = componentRef.current;

        if (!content) {
            console.error('Content not found.');
            return;
        }

        const pdf = new jsPDF('p', 'pt', 'a4');

        html2canvas(content, {
            scale: 2, // Higher scale for better quality
        })
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/jpeg');
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();
                const canvasWidth = canvas.width;
                const canvasHeight = canvas.height;
                const ratio = Math.min(pdfWidth / canvasWidth, pdfHeight / canvasHeight);

                // Calculate new dimensions for the image
                const imgWidth = canvasWidth * ratio;
                const imgHeight = canvasHeight * ratio;

                // Define offsets for centering and margin adjustment
                const xOffset = (pdfWidth - imgWidth) / 2;
                const yOffset = 10; // Adjust this value to reduce top margin

                pdf.addImage(imgData, 'JPEG', xOffset, yOffset, imgWidth, imgHeight);
                pdf.save('invoice.pdf');
            })
            .catch((error) => {
                console.error('Error generating PDF:', error);
            });
    };
    if (panelMode) {
        const isPaid = bookingInvoice?.payment_status === 'Paid' || bookingInvoice?.payment_status === 'Pre Paid';
        const InfoRow = ({ icon, label, value, valueColor }) => (
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75, py: 0.5, fontSize: '12px' }}>
                {icon && React.cloneElement(icon, { sx: { fontSize: 14, color: '#A72C68', mt: '2px', flexShrink: 0 } })}
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center', flex: 1, minWidth: 0 }}>
                    <Typography component="span" sx={{ fontSize: '12px', fontWeight: 600, color: '#1a1a2e' }}>{label}{value ? ':' : ''}</Typography>
                    {value && <Typography component="span" sx={{ fontSize: '12px', color: valueColor || '#3b4252', wordBreak: 'break-word' }}>{value}</Typography>}
                </Box>
            </Box>
        );
        return (
            <Box ref={scrollRef} sx={{ p: { xs: 1.5, md: 2.5 }, background: '#fff', position: 'relative' }}>
                {loading && <Waveloading cover />}

                {/* Breadcrumbs + Download PDF */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, gap: 1, flexWrap: 'wrap' }}>
                    <Breadcrumbs separator={<NavigateNextIconAlt fontSize="small" sx={{ color: '#1a1a2e' }} />} aria-label="breadcrumb" sx={{ '& .MuiBreadcrumbs-li': { fontSize: '12px' }, color: '#1a1a2e' }}>
                        <MuiLink component={Link} to={'/'} underline="hover" color="inherit" sx={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <ReceiptLongIcon sx={{ fontSize: 14 }} /> Home
                        </MuiLink>
                        <Typography sx={{ cursor: 'pointer', fontSize: '12px', color: '#1a1a2e', fontWeight: 600 }} onClick={handleNavigation}>
                            {bookingInvoice?.customer?.name}
                        </Typography>
                        {isFromAppointment ? (
                            <MuiLink component={Link} to={location.state?.from || '/crm/appointments'} underline="hover" color="inherit" sx={{ fontSize: '12px' }}>Booking Details</MuiLink>
                        ) : (
                            <MuiLink component={Link} to={'/crm/point-of-sale'} underline="hover" color="inherit" sx={{ fontSize: '12px' }}>(POS) Point of Sale</MuiLink>
                        )}
                        <Typography sx={{ fontSize: '12px', color: '#A72C68', fontWeight: 700 }}>View Invoice</Typography>
                    </Breadcrumbs>
                    <Button
                        variant="contained"
                        startIcon={<DownloadIcon sx={{ fontSize: '16px !important' }} />}
                        onClick={handleDownload}
                        sx={{
                            background: '#A72C68', color: '#fff',
                            textTransform: 'none', borderRadius: '10px',
                            px: 2, py: 1, fontWeight: 700, fontSize: '12px',
                            letterSpacing: '0.4px',
                            boxShadow: '0 2px 6px rgba(167,44,104,0.25)',
                            '&:hover': { background: '#921F58' },
                        }}
                    >
                        DOWNLOAD PDF
                    </Button>
                </Box>

                {/* Main invoice card */}
                <Box ref={componentRef} sx={{ background: '#fff', borderRadius: '14px', border: '1px solid #ECEDF2', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
                    {/* Top purple bar */}
                    <Box sx={{ height: 4, background: '#A72C68' }} />

                    {/* Invoice title + logo */}
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: { xs: 1.5, md: 2.5 }, gap: 1, flexWrap: 'wrap' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                            <Box sx={{ width: 42, height: 42, borderRadius: '10px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <ReceiptLongIcon sx={{ color: '#A72C68', fontSize: 22 }} />
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography sx={{ fontSize: { xs: '20px', md: '24px' }, fontWeight: 800, color: '#A72C68', letterSpacing: '1px', fontFamily: 'helvetica-lt-std-bold,sans-serif' }}>INVOICE</Typography>
                                <Box sx={{ background: '#FAEFF5', border: '1px solid #F0CDDB', borderRadius: '6px', px: 1, py: 0.25 }}>
                                    <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#A72C68' }}>#{bookingInvoice?.id || ''}</Typography>
                                </Box>
                            </Box>
                        </Box>
                        <img src={logo} alt="logo" style={{ maxWidth: 110, height: 'auto' }} />
                    </Box>

                    {/* Three-column info */}
                    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr 1fr' }, gap: 1.5, px: { xs: 1.5, md: 2.5 }, pb: 2 }}>
                        {/* FROM */}
                        <Box sx={{ background: '#FAFAFC', border: '1px solid #ECEDF2', borderRadius: '10px', p: 1.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                                <Box sx={{ width: 22, height: 22, borderRadius: '6px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <BadgeOutlinedIcon sx={{ fontSize: 14, color: '#A72C68' }} />
                                </Box>
                                <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#1a1a2e', textTransform: 'uppercase', letterSpacing: '0.5px' }}>FROM</Typography>
                            </Box>
                            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#1a1a2e', mb: 0.5 }}>{bookingInvoice?.provider?.name}</Typography>
                            <InfoRow icon={<LocalPhoneIcon />} label={bookingInvoice?.provider?.phone} />
                            <InfoRow icon={<LocationOnIcon />} label={bookingInvoice?.provider?.address?.address} />
                            <Typography sx={{ fontSize: '12px', color: '#1a1a2e', ml: '22px' }}>{[bookingInvoice?.provider?.address?.city, bookingInvoice?.provider?.address?.country].filter(Boolean).join(' ')}</Typography>
                        </Box>

                        {/* TO */}
                        <Box sx={{ background: '#FAFAFC', border: '1px solid #ECEDF2', borderRadius: '10px', p: 1.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                                <Box sx={{ width: 22, height: 22, borderRadius: '6px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <PersonOutlineIcon sx={{ fontSize: 14, color: '#A72C68' }} />
                                </Box>
                                <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#1a1a2e', textTransform: 'uppercase', letterSpacing: '0.5px' }}>TO</Typography>
                            </Box>
                            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#1a1a2e', mb: 0.5 }}>{bookingInvoice?.customer?.name}</Typography>
                            <InfoRow icon={<LocalPhoneIcon />} label={bookingInvoice?.customer?.phone} />
                            <InfoRow icon={<EmailIcon />} label={bookingInvoice?.customer?.email} />
                            <InfoRow icon={<LocationOnIcon />} label={bookingInvoice?.customer?.address?.address} />
                        </Box>

                        {/* INVOICE INFO */}
                        <Box sx={{ background: '#FAFAFC', border: '1px solid #ECEDF2', borderRadius: '10px', p: 1.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                                <Box sx={{ width: 22, height: 22, borderRadius: '6px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <InfoOutlinedIcon sx={{ fontSize: 14, color: '#A72C68' }} />
                                </Box>
                                <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#1a1a2e', textTransform: 'uppercase', letterSpacing: '0.5px' }}>INVOICE INFO</Typography>
                            </Box>
                            <InfoRow icon={<InfoOutlinedIcon />} label="Amount" value={`$${bookingInvoice?.grand_total || 0}`} />
                            <InfoRow icon={<CalendarMonthIcon />} label="Date" value={bookingInvoice?.date} />
                            {bookingInvoice?.start_time && bookingInvoice?.end_time && (
                                <InfoRow icon={<AccessTimeIcon />} label="Time" value={`${bookingInvoice.start_time} - ${bookingInvoice.end_time}`} />
                            )}
                            <InfoRow icon={<ReceiptLongIcon />} label="Invoice ID" value={bookingInvoice?.invoices_methods?.[0]?.id || 'N/A'} />
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, py: 0.5 }}>
                                <InfoOutlinedIcon sx={{ fontSize: 14, color: '#A72C68' }} />
                                <Typography component="span" sx={{ fontSize: '12px', fontWeight: 600, color: '#1a1a2e' }}>Status:</Typography>
                                <Box sx={{ background: isPaid ? '#1C7E46' : '#EB5757', color: '#fff', borderRadius: '12px', px: 1.25, py: 0.25, fontSize: '11px', fontWeight: 700 }}>
                                    {bookingInvoice?.payment_status || ''}
                                </Box>
                            </Box>
                            {bookingInvoice?.staff_name && (
                                <InfoRow icon={<PersonOutlineIcon />} label="Staff Name" value={bookingInvoice.staff_name} />
                            )}
                        </Box>
                    </Box>

                    {/* Service table */}
                    <Box sx={{ borderTop: '1px solid #ECEDF2' }}>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 90px 120px', px: { xs: 1.5, md: 2.5 }, py: 1.25, background: '#FAEFF5' }}>
                            <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#A72C68', textTransform: 'uppercase', letterSpacing: '0.5px' }}>SERVICE</Typography>
                            <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#A72C68', textTransform: 'uppercase', letterSpacing: '0.5px', textAlign: 'right' }}>QTY</Typography>
                            <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#A72C68', textTransform: 'uppercase', letterSpacing: '0.5px', textAlign: 'right' }}>AMOUNT</Typography>
                        </Box>
                        {bookingInvoice?.services?.map((item, idx) => (
                            <Box key={idx} sx={{ display: 'grid', gridTemplateColumns: '1fr 90px 120px', px: { xs: 1.5, md: 2.5 }, py: 1.25, borderTop: idx > 0 ? '1px solid #F1F2F6' : 'none' }}>
                                <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>{item?.name}</Typography>
                                <Typography sx={{ fontSize: '13px', color: '#1a1a2e', textAlign: 'right' }}>{item?.extra_quantity || item?.service_quantity || 1}</Typography>
                                <Typography sx={{ fontSize: '13px', color: '#1a1a2e', textAlign: 'right' }}>${item?.booking_cost}</Typography>
                            </Box>
                        ))}
                    </Box>

                    {/* Summary */}
                    <Box sx={{ borderTop: '1px solid #ECEDF2', p: { xs: 1.5, md: 2.5 }, background: '#FAFAFC' }}>
                        <Box sx={{ maxWidth: 380, ml: 'auto', display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            {[
                                { label: 'Sub Total (CAD)', value: `$${bookingInvoice?.service_cost || 0}` },
                                { label: 'Discount', value: `${parseFloat(bookingInvoice?.discount || 0) > 0 ? '-' : ''}$${bookingInvoice?.discount || 0}` },
                                { label: 'Amount', value: `$${bookingInvoice?.amount_after_discount || 0}`, bold: true },
                                { label: `Tax${bookingInvoice?.tax_percentage ? ` (${bookingInvoice.tax_percentage}%)` : ''}`, value: `$${bookingInvoice?.tax || 0}` },
                                { label: 'Tip', value: `$${bookingInvoice?.tip || 0}` },
                                { label: 'Grand Total', value: `$${bookingInvoice?.grand_total || 0}`, highlight: true },
                            ].map((r, i) => (
                                <Box key={i} sx={{
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                    py: '6px', px: r.highlight ? 1.25 : 0, mx: r.highlight ? -1.25 : 0,
                                    background: r.highlight ? '#FAEFF5' : 'transparent',
                                    borderRadius: r.highlight ? '8px' : 0,
                                    borderBottom: !r.highlight ? '1px dashed #ECEDF2' : 'none',
                                }}>
                                    <Typography sx={{ fontSize: '13px', fontWeight: r.bold || r.highlight ? 700 : 500, color: r.highlight ? '#A72C68' : '#3b4252' }}>{r.label}</Typography>
                                    <Typography sx={{ fontSize: '13px', fontWeight: r.bold || r.highlight ? 700 : 500, color: r.highlight ? '#A72C68' : '#1a1a2e' }}>{r.value}</Typography>
                                </Box>
                            ))}
                            {bookingInvoice?.invoices_methods?.map((m, i) => (
                                <Box key={`pm-${i}`} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px dashed #ECEDF2' }}>
                                    <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>{m?.payment_methods}</Typography>
                                    <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>{m?.payment_methods !== 'Future Payment' ? '-' : ''}${m?.amount}</Typography>
                                </Box>
                            ))}
                            <Box sx={{
                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                mt: 0.5, py: 1.25, px: 1.25, mx: -1.25,
                                background: '#FAEFF5', border: '1px solid #F0CDDB', borderRadius: '10px',
                            }}>
                                <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#A72C68' }}>Due Amount</Typography>
                                <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#A72C68' }}>${bookingInvoice?.due_amount || 0}</Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Footer */}
                    <Box sx={{ borderTop: '1px solid #ECEDF2', p: { xs: 1.5, md: 2 }, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap', gap: { xs: 1.5, sm: 2 }, justifyContent: { xs: 'flex-start', sm: 'space-around' }, alignItems: { xs: 'flex-start', sm: 'center' } }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Box sx={{ width: 30, height: 30, borderRadius: '8px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <LanguageIcon sx={{ fontSize: 16, color: '#A72C68' }} />
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: '11px', color: '#0F172A', fontWeight: 700 }}>Website</Typography>
                                <Typography sx={{ fontSize: '12px', color: '#1a1a2e', fontWeight: 600 }}>3dlifestyle.ca</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Box sx={{ width: 30, height: 30, borderRadius: '8px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <EmailIcon sx={{ fontSize: 16, color: '#A72C68' }} />
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: '11px', color: '#0F172A', fontWeight: 700 }}>Email</Typography>
                                <Typography sx={{ fontSize: '12px', color: '#1a1a2e', fontWeight: 600, wordBreak: 'break-word' }}>{bookingInvoice?.provider?.email}</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Box sx={{ width: 30, height: 30, borderRadius: '8px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <LocalPhoneIcon sx={{ fontSize: 16, color: '#A72C68' }} />
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: '11px', color: '#0F172A', fontWeight: 700 }}>Phone</Typography>
                                <Typography sx={{ fontSize: '12px', color: '#1a1a2e', fontWeight: 600 }}>{bookingInvoice?.provider?.phone}</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }

    return (
        <Box ref={scrollRef} sx={{ width: '100%', boxSizing: 'border-box', overflowX: 'hidden', p: { xs: 1.5, md: 2.5 }, background: '#fff' }}>
            {loading && <Waveloading fullSize />}

            {/* Top bar: back + breadcrumbs + action buttons */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5, mb: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0, flex: { xs: '1 1 100%', sm: 1 } }}>
                    <Paper
                        component={Link}
                        to={'/crm/point-of-sale'}
                        sx={{
                            width: 36, height: 36,
                            borderRadius: '10px',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer',
                            border: '1px solid #F0CDDB',
                            background: '#fff',
                            transition: 'all 0.2s ease',
                            '&:hover': { background: '#FAEFF5', borderColor: '#A72C68' },
                        }}
                        elevation={0}
                    >
                        <ArrowBackIosIcon sx={{ fontSize: 16, color: '#A72C68', ml: '6px' }} />
                    </Paper>
                    <Breadcrumbs
                        separator={<NavigateNextIconAlt fontSize="small" sx={{ color: '#1a1a2e' }} />}
                        aria-label="breadcrumb"
                        sx={{ '& .MuiBreadcrumbs-li': { fontSize: '13px' }, color: '#1a1a2e' }}
                    >
                        <MuiLink component={Link} to={'/'} underline="hover" color="inherit" sx={{ fontSize: '13px', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <ReceiptLongIcon sx={{ fontSize: 15 }} /> Home
                        </MuiLink>
                        {isFromAppointment && (
                            <MuiLink component={Link} to={'/crm/appointments'} underline="hover" color="inherit" sx={{ fontSize: '13px' }}>
                                Appointment
                            </MuiLink>
                        )}
                        <Typography
                            sx={{ cursor: 'pointer', fontSize: '13px', color: '#1a1a2e', fontWeight: 600 }}
                            onClick={handleNavigation}
                        >
                            {bookingInvoice?.customer?.name}
                        </Typography>
                        {isFromAppointment ? (
                            <MuiLink component={Link} to={location.state?.from || '/crm/appointments'} underline="hover" color="inherit" sx={{ fontSize: '13px' }}>
                                Booking Details
                            </MuiLink>
                        ) : (
                            <MuiLink component={Link} to={'/crm/point-of-sale'} underline="hover" color="inherit" sx={{ fontSize: '13px' }}>
                                (POS) Point of Sale
                            </MuiLink>
                        )}
                        <Typography sx={{ fontSize: '13px', color: '#A72C68', fontWeight: 700 }}>
                            View Invoice
                        </Typography>
                    </Breadcrumbs>
                </Box>

                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', width: { xs: '100%', sm: 'auto' } }}>
                    {autoDownload === 'true' && (
                        <Button
                            onClick={handleNewAppointment}
                            sx={{
                                background: '#fff', color: '#A72C68',
                                border: '1.5px solid #A72C68',
                                textTransform: 'none', borderRadius: '10px',
                                px: 2, py: 1, fontWeight: 700, fontSize: '13px',
                                width: { xs: '100%', sm: 'auto' },
                                '&:hover': { background: '#FAEFF5', borderColor: '#921F58' },
                            }}
                        >
                            Book A New Appointment
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        startIcon={<DownloadIcon sx={{ fontSize: '18px !important' }} />}
                        onClick={handleDownload}
                        sx={{
                            background: 'linear-gradient(135deg,#A72C68 0%,#921F58 100%)',
                            color: '#fff',
                            textTransform: 'none', borderRadius: '10px',
                            px: 2.5, py: 1, fontWeight: 700, fontSize: '13px',
                            letterSpacing: '0.4px',
                            boxShadow: '0 2px 8px rgba(167,44,104,0.25)',
                            width: { xs: '100%', sm: 'auto' },
                            '&:hover': { background: 'linear-gradient(135deg,#921F58 0%,#7E1A4C 100%)' },
                        }}
                    >
                        DOWNLOAD PDF
                    </Button>
                </Box>
            </Box>

            {/* Main invoice card (same content as panelMode) */}
            <Box ref={componentRef} sx={{ background: '#fff', borderRadius: '14px', border: '1px solid #ECEDF2', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
                {/* Top burgundy bar */}
                <Box sx={{ height: 4, background: '#A72C68' }} />

                {/* Invoice title + logo */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: { xs: 1.5, md: 2.5 }, gap: 1, flexWrap: 'wrap' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                        <Box sx={{ width: 46, height: 46, borderRadius: '10px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <ReceiptLongIcon sx={{ color: '#A72C68', fontSize: 24 }} />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography sx={{ fontSize: { xs: '22px', md: '28px' }, fontWeight: 800, color: '#A72C68', letterSpacing: '1px', fontFamily: 'helvetica-lt-std-bold,sans-serif' }}>INVOICE</Typography>
                            <Box sx={{ background: '#FAEFF5', border: '1px solid #F0CDDB', borderRadius: '6px', px: 1, py: 0.25 }}>
                                <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#A72C68' }}>#{bookingInvoice?.id || ''}</Typography>
                            </Box>
                        </Box>
                    </Box>
                    <img src={logo} alt="logo" style={{ maxWidth: isMobile ? 90 : 130, height: 'auto' }} />
                </Box>

                {/* Three-column info */}
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr 1fr' }, gap: 1.5, px: { xs: 1.5, md: 2.5 }, pb: 2 }}>
                    {/* FROM */}
                    <Box sx={{ background: '#FAFAFC', border: '1px solid #ECEDF2', borderRadius: '10px', p: 1.75 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                            <Box sx={{ width: 24, height: 24, borderRadius: '6px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <BadgeOutlinedIcon sx={{ fontSize: 15, color: '#A72C68' }} />
                            </Box>
                            <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#1a1a2e', textTransform: 'uppercase', letterSpacing: '0.5px' }}>FROM</Typography>
                        </Box>
                        <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1a1a2e', mb: 0.75 }}>{bookingInvoice?.provider?.name}</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75, py: 0.25 }}>
                            <LocalPhoneIcon sx={{ fontSize: 15, color: '#A72C68', mt: '2px' }} />
                            <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>{bookingInvoice?.provider?.phone}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75, py: 0.25 }}>
                            <LocationOnIcon sx={{ fontSize: 15, color: '#A72C68', mt: '2px' }} />
                            <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>{bookingInvoice?.provider?.address?.address}</Typography>
                        </Box>
                        {(bookingInvoice?.provider?.address?.city || bookingInvoice?.provider?.address?.country) && (
                            <Typography sx={{ fontSize: '13px', color: '#1a1a2e', ml: '22px' }}>
                                {[bookingInvoice?.provider?.address?.city, bookingInvoice?.provider?.address?.country].filter(Boolean).join(' ')}
                            </Typography>
                        )}
                    </Box>

                    {/* TO */}
                    <Box sx={{ background: '#FAFAFC', border: '1px solid #ECEDF2', borderRadius: '10px', p: 1.75 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                            <Box sx={{ width: 24, height: 24, borderRadius: '6px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <PersonOutlineIcon sx={{ fontSize: 15, color: '#A72C68' }} />
                            </Box>
                            <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#1a1a2e', textTransform: 'uppercase', letterSpacing: '0.5px' }}>TO</Typography>
                        </Box>
                        <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1a1a2e', mb: 0.75 }}>{bookingInvoice?.customer?.name}</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75, py: 0.25 }}>
                            <LocalPhoneIcon sx={{ fontSize: 15, color: '#A72C68', mt: '2px' }} />
                            <a href={`tel:${bookingInvoice?.customer?.phone}`} style={{ textDecoration: 'none', color: '#1a1a2e', fontSize: '13px' }}>
                                {bookingInvoice?.customer?.phone}
                            </a>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75, py: 0.25 }}>
                            <EmailIcon sx={{ fontSize: 15, color: '#A72C68', mt: '2px' }} />
                            <a href={`mailto:${bookingInvoice?.customer?.email}`} style={{ textDecoration: 'none', color: '#1a1a2e', fontSize: '13px', overflowWrap: 'anywhere' }}>
                                {bookingInvoice?.customer?.email}
                            </a>
                        </Box>
                        {bookingInvoice?.customer?.address?.address && (
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75, py: 0.25 }}>
                                <LocationOnIcon sx={{ fontSize: 15, color: '#A72C68', mt: '2px' }} />
                                <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>{bookingInvoice?.customer?.address?.address}</Typography>
                            </Box>
                        )}
                    </Box>

                    {/* INVOICE INFO */}
                    <Box sx={{ background: '#FAFAFC', border: '1px solid #ECEDF2', borderRadius: '10px', p: 1.75 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                            <Box sx={{ width: 24, height: 24, borderRadius: '6px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <InfoOutlinedIcon sx={{ fontSize: 15, color: '#A72C68' }} />
                            </Box>
                            <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#1a1a2e', textTransform: 'uppercase', letterSpacing: '0.5px' }}>INVOICE INFO</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, py: 0.25 }}>
                            <InfoOutlinedIcon sx={{ fontSize: 15, color: '#A72C68' }} />
                            <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#1a1a2e' }}>Amount:</Typography>
                            <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>${bookingInvoice?.grand_total || 0}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, py: 0.25 }}>
                            <CalendarMonthIcon sx={{ fontSize: 15, color: '#A72C68' }} />
                            <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#1a1a2e' }}>Date:</Typography>
                            <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>{bookingInvoice?.date}</Typography>
                        </Box>
                        {bookingInvoice?.start_time && bookingInvoice?.end_time && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, py: 0.25 }}>
                                <AccessTimeIcon sx={{ fontSize: 15, color: '#A72C68' }} />
                                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#1a1a2e' }}>Time:</Typography>
                                <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>{bookingInvoice.start_time} - {bookingInvoice.end_time}</Typography>
                            </Box>
                        )}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, py: 0.25 }}>
                            <ReceiptLongIcon sx={{ fontSize: 15, color: '#A72C68' }} />
                            <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#1a1a2e' }}>Invoice ID:</Typography>
                            <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>{bookingInvoice?.invoices_methods?.[0]?.id || 'N/A'}</Typography>
                        </Box>
                        {bookingInvoice?.invoices_methods?.[0]?.payment_methods === "Finance Company" && bookingInvoice?.invoices?.[0]?.institution_name && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, py: 0.25 }}>
                                <BadgeOutlinedIcon sx={{ fontSize: 15, color: '#A72C68' }} />
                                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#1a1a2e' }}>Institution:</Typography>
                                <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>{bookingInvoice.invoices[0].institution_name}</Typography>
                            </Box>
                        )}
                        {bookingInvoice?.invoices_methods?.[0]?.payment_methods === "Finance Company" && bookingInvoice?.invoices?.[0]?.approval_code && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, py: 0.25 }}>
                                <BadgeOutlinedIcon sx={{ fontSize: 15, color: '#A72C68' }} />
                                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#1a1a2e' }}>Approval Code:</Typography>
                                <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>{bookingInvoice.invoices[0].approval_code}</Typography>
                            </Box>
                        )}
                        {bookingInvoice?.invoices?.some(inv => inv.transaction_id) && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, py: 0.25 }}>
                                <ReceiptLongIcon sx={{ fontSize: 15, color: '#A72C68' }} />
                                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#1a1a2e' }}>Transaction ID:</Typography>
                                <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>
                                    {bookingInvoice.invoices.find(inv => inv.transaction_id)?.transaction_id}
                                </Typography>
                            </Box>
                        )}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, py: 0.5 }}>
                            <InfoOutlinedIcon sx={{ fontSize: 15, color: '#A72C68' }} />
                            <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#1a1a2e' }}>Status:</Typography>
                            <Box sx={{
                                background: (bookingInvoice?.payment_status === 'Paid' || bookingInvoice?.payment_status === 'Pre Paid') ? '#1C7E46' : '#EB5757',
                                color: '#fff', borderRadius: '12px', px: 1.5, py: 0.25, fontSize: '11px', fontWeight: 700,
                            }}>
                                {bookingInvoice?.payment_status || ''}
                            </Box>
                        </Box>
                        {bookingInvoice?.staff_name && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, py: 0.25 }}>
                                <PersonOutlineIcon sx={{ fontSize: 15, color: '#A72C68' }} />
                                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#1a1a2e' }}>Staff Name:</Typography>
                                <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>{bookingInvoice.staff_name}</Typography>
                            </Box>
                        )}
                    </Box>
                </Box>

                {/* Service table */}
                <Box sx={{ borderTop: '1px solid #ECEDF2' }}>
                    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 90px 120px', md: '1fr 320px 120px' }, px: { xs: 1.5, md: 2.5 }, py: 1.5, background: '#FAEFF5' }}>
                        <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#A72C68', textTransform: 'uppercase', letterSpacing: '0.5px' }}>SERVICE</Typography>
                        <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#A72C68', textTransform: 'uppercase', letterSpacing: '0.5px', textAlign: { xs: 'right', md: 'left' } }}>QTY</Typography>
                        <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#A72C68', textTransform: 'uppercase', letterSpacing: '0.5px', textAlign: 'right' }}>AMOUNT</Typography>
                    </Box>
                    {bookingInvoice?.services?.map((item, idx) => (
                        <Box key={idx} sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 90px 120px', md: '1fr 320px 120px' }, px: { xs: 1.5, md: 2.5 }, py: 1.5, borderTop: idx > 0 ? '1px solid #F1F2F6' : 'none' }}>
                            <Typography sx={{ fontSize: '14px', color: '#1a1a2e' }}>{item?.name}</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#1a1a2e', textAlign: { xs: 'right', md: 'left' } }}>{item?.extra_quantity || item?.service_quantity || 1}</Typography>
                            <Typography sx={{ fontSize: '14px', color: '#1a1a2e', textAlign: 'right' }}>${item?.booking_cost}</Typography>
                        </Box>
                    ))}
                </Box>

                {/* Summary */}
                <Box sx={{ borderTop: '1px solid #ECEDF2', p: { xs: 1.5, md: 2.5 }, background: '#FAFAFC' }}>
                    <Box sx={{ width: { xs: '100%', md: 440 }, maxWidth: '100%', ml: 'auto', display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        {[
                            { label: 'Sub Total (CAD)', value: `$${bookingInvoice?.service_cost || 0}` },
                            { label: 'Discount', value: `${parseFloat(bookingInvoice?.discount || 0) > 0 ? '-' : ''}$${bookingInvoice?.discount || 0}` },
                            { label: 'Amount', value: `$${bookingInvoice?.amount_after_discount || 0}`, bold: true },
                            { label: `Tax${bookingInvoice?.tax_percentage ? ` (${bookingInvoice.tax_percentage}%)` : ''}`, value: `$${bookingInvoice?.tax || 0}` },
                            { label: 'Tip', value: `$${bookingInvoice?.tip || 0}` },
                            { label: 'Grand Total', value: `$${bookingInvoice?.grand_total || 0}`, highlight: true },
                        ].map((r, i) => (
                            <Box key={i} sx={{
                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                py: '8px', px: r.highlight ? 1.5 : 0, mx: r.highlight ? -1.5 : 0,
                                background: r.highlight ? '#FAEFF5' : 'transparent',
                                borderRadius: r.highlight ? '8px' : 0,
                                borderBottom: !r.highlight ? '1px dashed #ECEDF2' : 'none',
                            }}>
                                <Typography sx={{ fontSize: '14px', fontWeight: r.bold || r.highlight ? 700 : 500, color: r.highlight ? '#A72C68' : '#3b4252' }}>{r.label}</Typography>
                                <Typography sx={{ fontSize: '14px', fontWeight: r.bold || r.highlight ? 700 : 500, color: r.highlight ? '#A72C68' : '#1a1a2e' }}>{r.value}</Typography>
                            </Box>
                        ))}
                        {bookingInvoice?.invoices_methods?.map((m, i) => (
                            <Box key={`pm-${i}`} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: '8px', borderBottom: '1px dashed #ECEDF2' }}>
                                <Typography sx={{ fontSize: '14px', color: '#1a1a2e' }}>{m?.payment_methods}</Typography>
                                <Typography sx={{ fontSize: '14px', color: '#1a1a2e' }}>{m?.payment_methods !== 'Future Payment' ? '-' : ''}${m?.amount}</Typography>
                            </Box>
                        ))}
                        <Box sx={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            mt: 0.5, py: 1.5, px: 1.5, mx: -1.5,
                            background: '#FAEFF5', border: '1px solid #F0CDDB', borderRadius: '10px',
                        }}>
                            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#A72C68' }}>Due Amount</Typography>
                            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#A72C68' }}>${bookingInvoice?.due_amount || 0}</Typography>
                        </Box>
                    </Box>
                </Box>

                {/* Footer */}
                <Box sx={{ borderTop: '1px solid #ECEDF2', p: { xs: 1.5, md: 2 }, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap', gap: { xs: 1.5, sm: 2 }, justifyContent: { xs: 'flex-start', sm: 'space-around' }, alignItems: { xs: 'flex-start', sm: 'center' } }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ width: 34, height: 34, borderRadius: '8px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <LanguageIcon sx={{ fontSize: 18, color: '#A72C68' }} />
                        </Box>
                        <Box>
                            <Typography sx={{ fontSize: '11px', color: '#0F172A', fontWeight: 700 }}>Website</Typography>
                            <Typography sx={{ fontSize: '13px', color: '#1a1a2e', fontWeight: 600 }}>3dlifestyle.ca</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ width: 34, height: 34, borderRadius: '8px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <EmailIcon sx={{ fontSize: 18, color: '#A72C68' }} />
                        </Box>
                        <Box>
                            <Typography sx={{ fontSize: '11px', color: '#0F172A', fontWeight: 700 }}>Email</Typography>
                            <Typography sx={{ fontSize: '13px', color: '#1a1a2e', fontWeight: 600, wordBreak: 'break-word' }}>{bookingInvoice?.provider?.email}</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ width: 34, height: 34, borderRadius: '8px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <LocalPhoneIcon sx={{ fontSize: 18, color: '#A72C68' }} />
                        </Box>
                        <Box>
                            <Typography sx={{ fontSize: '11px', color: '#0F172A', fontWeight: 700 }}>Phone</Typography>
                            <Typography sx={{ fontSize: '13px', color: '#1a1a2e', fontWeight: 600 }}>{formatPhoneNumber(bookingInvoice?.provider?.phone)}</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};
export default Invoices;
